<template>
  <el-container class="OrderPrintForm">
    <div id="print">
      <el-main ref="printForm" class="p-0">
        <table class="table-print table-border__solid">
          <tr>
            <td
              colspan="4"
              rowspan="4"
              align="center"
            >
              <font size="5"><h1>발 주 서</h1></font>
            </td>
            <td colspan="3" align="center">
              결제
            </td>
          </tr>
          <tr>
            <td align="center" width="10%">담 당</td>
            <td align="center" width="10%">확 인</td>
            <td align="center" width="10%">승 인</td>
          </tr>
          <tr>
            <td rowspan="2"></td>
            <td rowspan="2"></td>
            <td rowspan="2"></td>
          </tr>
          <tr></tr>
          <tr>
            <td width="10%">발주번호</td>
            <td width="20%">{{ data.code }}</td>
            <td width="10%">발주 일자</td>
            <td>{{ data.order_date }}</td>
            <td width="10%">납기 일자</td>
            <td colspan="2">{{ data.valid_date }}</td>
          </tr>
          <tr>
            <td rowspan="2">수 신 처</td>
            <td rowspan="2">{{ data.customer_name }}</td>
            <td>주 소</td>
            <td>{{ customer.addr }}</td>
            <td>TEL</td>
            <td colspan="2">{{ customer.tel }}</td>
          </tr>
          <tr>
            <td>담당자</td>
            <td>{{ data.customer_charger }}</td>
            <td>FAX</td>
            <td colspan="2">{{ customer.fax }}</td>
          </tr>
          <tr>
            <td rowspan="2">발 신 처</td>
            <td rowspan="2">{{company.name}}</td>
            <td>주소</td>
            <td>{{company.addr}}</td>
            <td>TEL</td>
            <td colspan="2">{{company.tel}}</td>
          </tr>
          <tr>
            <td>담당자</td>
            <td>{{ data.charger }}</td>
            <td>FAX</td>
            <td colspan="2">{{company.fax}}</td>
          </tr>
          <tr>
            <td>납 품 지</td>
            <td colspan="6">{{ data.destination }}</td>
          </tr>
        </table>
        <div
          class="sum-row mt-default"
        >
          <el-row>
            <el-col :span="4" class="sum-title">합계금액</el-col>
            <el-col :span="10" class="sum-column">{{ data.price | numberToKorean }}</el-col>
            <el-col :span="10" class="sum-column"
              >￦ {{ util.numberWComma(data.price) }}</el-col
            >
          </el-row>
        </div>
        <table class="table-print table-border__solid mt-default">
          <thead>
            <tr>
              <th width="30">No.</th>
              <th width="200">품명</th>
              <th :width="$width.size">{{ $t("lang.size") }}</th>
              <th :width="$width.unit_name">단위</th>
              <th :width="$width.amount">수량</th>
              <th :width="$width.price">금액</th>
              <th>비고</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in data.details" v-bind:key="item.seq">
              <td class="text-align-center">{{ item.seq }}</td>
              <td>{{ item.product_name }}</td>
              <td>{{ item.size }}</td>
              <td class="text-align-center">{{ item.unit_name }}</td>
              <td class="text-align-right">{{ item.amount | number }}</td>
              <td class="text-align-right">{{ item.supply_price | number }}</td>
              <td>{{ item.desc }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td class="text-align-center" colspan="4">합계</td>
              <td class="text-align-right">
                {{
                  data.details.reduce((sum, item) => sum + item.amount, 0)
                    | number
                }}
              </td>
              <td class="text-align-right">
                {{
                  data.details.reduce((sum, item) => sum + item.supply_price, 0)
                    | number
                }}
              </td>
              <td></td>
            </tr>
            <tr>
              <td colspan="7">{{ data.desc }}</td>
            </tr>
          </tfoot>
        </table>
        <el-row type="flex" justify="space-between" style="margin-top: 6px">
          <div>
            <div class="image-display" 
              v-show="file_list.length > 0" 
              v-for="(file, index) in file_list" :key="file" 
            >
              <img :src="file" @click="removeImage(index)"/>
            </div>
          </div>
        </el-row>
        <el-row type="flex" justify="space-between" style="margin-top: 6px">
          <span class="text-color-red">{{
            $t("lang.software_consulting")
          }}</span>
          <span class="text-color-red">{{ $t("lang.homepage") }}</span>
        </el-row>
      </el-main>
    </div>
    <el-footer>
      <el-button type="primary" v-shortkey="['f8']" @click="onPrint">
        발주서 출력 (F8)
      </el-button>
      <el-button @click="clickImageUpload">이미지 첨부</el-button>
      <input type='file' id="imageUpload" @change="onImageUpload" style="display:none" multiple />
      <el-button class="close-button" @click="closeDialog"
        >{{ $t("button.close") }}(Esc)</el-button
      >
    </el-footer>
  </el-container>
</template>
<script>
import { mapGetters } from "vuex";
import { form } from "@/common/mixins/form";
import { company_info } from "@/common/mixins/company_info";
import Print from "../../plugins/print/print";
import Vue from "vue";

Vue.use(Print);

export default {
  name: "OrderPrintForm",
  mixins: [company_info, form],
  components: {},
  data() {
    return {
      sum: 0,
      form_data: undefined,
      customer: {},
      file_list: [],
      remove_index: null,
    };
  },
  props: {
    data: {
      type: Object,
      default: function () {
        return {
          id: 0,
          code: "",
          customer_id: 0,
          order_date: this.util.getDate(0),
          valid_date: this.util.getDate(30),
          customer_charger: "",
          addr: "",
          name: "",
          status_flag: "N",
          tel: "",
          fax: "",
          price: 0,
          cost: 0,
          owner: "",
          details: [],
        };
      },
    },
  },
  computed: {
    ...mapGetters(["table_customer", "table_config"]),
    is_new: function () {
      return this.data.id < 1;
    },
  },
  mounted() {
    this.loadConfig();
    this.customer = this.table_customer.find(c => c.id === this.data.customer_id);
  },
  methods: {
    onPrint() {
      this.$print(this.$refs.printForm);
      // var initBody;
      // window.onbeforeprint = function () {
      //     initBody = document.body.innerHTML;
      //     document.body.innerHTML = document.getElementById('print').innerHTML;
      // };
      // window.onafterprint = function () {
      //     document.body.innerHTML = initBody;
      // };
      // window.print();
      // location.reload()
    },
    handleCompleted(message) {
      this.childdialogVisible = false;
      if (!message) {
        return;
      }
      this.$notify(message);
    },
    handleChangedSum(sum) {
      this.sum = sum;
    },
    /** 데이터 값 정리 */
    /** noti 옵션 반환 */
    getNotifyOptions(message) {
      return this.util.get_notify_options("s", "거래처", message);
    },
    notifyError(message) {
      this.util.notify_error(this, "발주", message);
    },
    onImageUpload(event) {
      // var file = document.getElementById('imageUpload');
			// var filePath = file.value; // 파일 경로
      // var fileList = file.files; // 선택된 파일 정보

      var files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      files.forEach(item => {
        this.createImage(item);
      });
    },
    createImage(file) {
      let reader = new FileReader();
      reader.onload = (event) => {
        this.file_list.push(event.target.result);
      };
      reader.readAsDataURL(file);
    },
    removeImage: function (index) {
      this.remove_index = index;
      this.util.confirm(this, this.title, "이미지를 삭제하시겠습니까?", this.handleOK);
    },
    handleOK: function() {
      this.file_list.splice(this.remove_index, 1);
    },
    clickImageUpload: function() {
      document.getElementById('imageUpload').click();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/_variables.scss";
.printform-dialog {
  width: 900px;
  height: unset !important;
}
.el-dialog__body .el-main {
  height: unset;
}
.text-align-right {
  text-align: right;
}
.text-align-center {
  text-align: center;
}
.text-color-red {
  color: red;
}
$padding-td: 4px 4px;
.table-print {
  width: 100%;
  border-collapse: collapse;
  border-style: solid;
  th {
    padding: 2px 0;
  }
  td {
    padding: $padding-td;
  }
}
.sum-row {
  border: 1px solid #606266;
  .sum-column {
    border-left: 1px solid #606266;
  }
}
.image-display {
  margin:10px 10px 0 0;
  display:inline-flex;
}
</style>
